import { action } from 'satcheljs';
import { TxpEventFlags, TxpStateFlags } from '../store/schema/TxpGriffinSettingsPayload';

export const updateTxpSettingFlag = action(
    'updateTxpSettingFlag',
    (flagName: TxpStateFlags | TxpEventFlags, enabled?: boolean, value?: number) => ({
        flagName: flagName,
        enabled: enabled,
        value: value,
    })
);
